import { Card } from "@/components/ui/card";
import { ChatMessage as ChatMessageType } from "@/hooks/useChat";

interface ChatMessageProps {
  message: ChatMessageType;
}

export const ChatMessage = ({ message }: ChatMessageProps) => {
  return (
    <Card 
      className={`p-4 max-w-[80%] ${
        message.role === 'assistant' 
          ? 'ml-0 bg-muted' 
          : 'ml-auto bg-primary/10'
      }`}
    >
      <p className="text-sm whitespace-pre-wrap">{message.message}</p>
    </Card>
  );
};